// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// global page threshold effect - kan triggas från vilken sida som helst

(function() {
  'use strict';

  // global state
  let thresholdActive = false;
  const processedImages = new Set();

  // threshold settings (matchar site background)
  const THRESHOLD_VALUE = 128; // ljus/mörk-gräns (0-255)
  const LIGHT_COLOR = { r: 214, g: 214, b: 214 }; // site background grey (#D6D6D6)
  const DARK_COLOR = { r: 40, g: 39, b: 39 }; // mörk grå

  // selectors för element som ska exkluderas från threshold
  const EXCLUDE_SELECTORS = [
    '.custom-header img',
    '.custom-footer img',
    '.custom-footer-wrapper img',
    'header img',
    'footer img',
    '.bxyz-archive__modal img',
    '.bxyz-archive__modal-image',
    '.bxyz-newsletter-modal img',
    '.bxyz-nlbtn-svg img',
    '[data-bxyz-no-threshold] img',
    'img[data-bxyz-no-threshold]'
  ].join(',');

  // selectors för text-element som ska döljas under threshold
  const HIDE_TEXT_SELECTORS = [
    'main figcaption',
    'main .product-title',
    'main .product-price',
    'main .price',
    'main h1', 'main h2', 'main h3', 'main h4', 'main h5', 'main h6',
    'main p',
    'main .caption',
    'main .text-overlay',
    'main .product-info',
    'main .collection-title',
    'main .bxyz-product-grid__title',
    'main .bxyz-fs-s', 'main .bxyz-fs-m', 'main .bxyz-fs-l', 'main .bxyz-fs-xl'
  ].join(',');

  /**
   * applicera binär threshold på en bild
   */
  function applyThresholdToImage(img, callback) {
    if (processedImages.has(img)) {
      if (callback) callback();
      return;
    }
    if (!img.src || img.src.startsWith('data:')) {
      // debug: logga varför arkivbilder hoppas över
      if (img.closest('.bxyz-archive__item')) {
        console.log('[BXYZ] skipping archive image (data: URL):', img.src.substring(0, 50) + '...');
      }
      if (callback) callback();
      return;
    }

    // spara original
    if (!img.dataset.bxyzOriginalSrc) {
      img.dataset.bxyzOriginalSrc = img.src;
    }

    const applyFilter = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const tempImg = new Image();
      tempImg.crossOrigin = 'anonymous';

      tempImg.onload = function() {
        try {
          // mindre upplösning för snabbare processing
          const targetW = Math.min(400, tempImg.naturalWidth);
          const aspect = tempImg.naturalHeight > 0 ? tempImg.naturalWidth / tempImg.naturalHeight : 1;
          canvas.width = targetW;
          canvas.height = Math.floor(targetW / aspect);

          ctx.imageSmoothingEnabled = false;
          ctx.drawImage(tempImg, 0, 0, canvas.width, canvas.height);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          // binär tröskel
          for (let i = 0; i < data.length; i += 4) {
            const r = data[i], g = data[i+1], b = data[i+2];
            const gray = 0.299*r + 0.587*g + 0.114*b;
            const on = gray >= THRESHOLD_VALUE;
            data[i] = on ? LIGHT_COLOR.r : DARK_COLOR.r;
            data[i+1] = on ? LIGHT_COLOR.g : DARK_COLOR.g;
            data[i+2] = on ? LIGHT_COLOR.b : DARK_COLOR.b;
          }

          ctx.putImageData(imageData, 0, 0);
          img.src = canvas.toDataURL();
          processedImages.add(img);
          if (callback) callback();
        } catch(e) {
          console.warn('[BXYZ] threshold processing error:', e);
          if (callback) callback();
        }
      };

      tempImg.onerror = function() {
        console.warn('[BXYZ] failed to load image for threshold:', img.dataset.bxyzOriginalSrc);
        if (callback) callback();
      };

      tempImg.src = img.dataset.bxyzOriginalSrc;
    };

    if (img.complete && img.naturalWidth > 0) {
      applyFilter();
    } else {
      img.addEventListener('load', applyFilter, { once: true });
    }
  }

  /**
   * dölj text-element (endast i main-området)
   */
  function hideTextElements() {
    const textElements = document.querySelectorAll(HIDE_TEXT_SELECTORS);
    
    textElements.forEach((el) => {
      // spara original display-värde
      if (!el.dataset.bxyzOriginalDisplay) {
        el.dataset.bxyzOriginalDisplay = window.getComputedStyle(el).display;
      }
      
      el.style.display = 'none';
    });
  }

  /**
   * visa text-element igen
   */
  function showTextElements() {
    const textElements = document.querySelectorAll('[data-bxyz-original-display]');
    
    textElements.forEach((el) => {
      const originalDisplay = el.dataset.bxyzOriginalDisplay;
      el.style.display = originalDisplay;
      delete el.dataset.bxyzOriginalDisplay;
    });
  }

  /**
   * applicera threshold på hela sidan
   */
  function applyPageThreshold() {
    // omedelbar visuell feedback - dölj text direkt
    hideTextElements();
    
    // lägg till body-klass för omedelbar styling
    document.body.classList.add('bxyz-threshold-active');
    
    // fade ut lite för smooth övergång
    document.body.style.opacity = '0.8';
    document.body.style.transition = 'opacity 0.3s ease';
    
    // hitta alla bilder utanför header och footer
    const images = document.querySelectorAll('img');
    let processedCount = 0;
    const totalImages = Array.from(images).filter(img => !img.matches(EXCLUDE_SELECTORS)).length;
    
    // om inga bilder att processa, återställ opacity direkt
    if (totalImages === 0) {
      setTimeout(() => {
        document.body.style.opacity = '1';
      }, 100);
      return;
    }
    
    const onImageProcessed = () => {
      processedCount++;
      // när alla bilder är processade, fade in
      if (processedCount >= totalImages) {
        setTimeout(() => {
          document.body.style.opacity = '1';
        }, 100);
      }
    };
    
    images.forEach((img) => {
      // skippa exkluderade element
      if (img.matches(EXCLUDE_SELECTORS)) return;
      
      // debug: logga vilka bilder som processas
      if (img.closest('.bxyz-archive__item')) {
        console.log('[BXYZ] processing archive image:', img.src);
      }
      
      // lägg till transition på bilden
      img.style.transition = 'opacity 0.3s ease';
      applyThresholdToImage(img, onImageProcessed);
    });
  }

  /**
   * återställ alla bilder till original
   */
  function removePageThreshold() {
    // fade ut först
    document.body.style.opacity = '0.8';
    
    setTimeout(() => {
      const images = document.querySelectorAll('img[data-bxyz-original-src]');
      images.forEach((img) => {
        if (img.dataset.bxyzOriginalSrc) {
          img.src = img.dataset.bxyzOriginalSrc;
          delete img.dataset.bxyzOriginalSrc;
          processedImages.delete(img);
          // ta bort transition
          img.style.transition = '';
        }
      });

      // visa text igen
      showTextElements();
      
      // fade in tillbaka
      document.body.style.opacity = '1';
      
      // rensa transition efter animation
      setTimeout(() => {
        document.body.style.transition = '';
        document.body.style.opacity = '';
      }, 300);
    }, 50);
  }

  /**
   * toggle threshold on/off
   */
  function togglePageThreshold() {
    thresholdActive = !thresholdActive;
    
    if (thresholdActive) {
      applyPageThreshold();
      document.body.classList.add('bxyz-threshold-active');
    } else {
      removePageThreshold();
      document.body.classList.remove('bxyz-threshold-active');
    }

    // dispatcha custom event så andra scripts kan reagera
    document.dispatchEvent(new CustomEvent('bxyz:threshold-toggled', {
      detail: { active: thresholdActive }
    }));

    return thresholdActive;
  }

  /**
   * aktivera threshold (om inte redan aktiv)
   */
  function enablePageThreshold() {
    if (!thresholdActive) {
      togglePageThreshold();
    }
  }

  /**
   * deaktivera threshold (om aktiv)
   */
  function disablePageThreshold() {
    if (thresholdActive) {
      togglePageThreshold();
    }
    
    // force cleanup - säkerställ att alla bilder återställs
    setTimeout(() => {
      const lingering = document.querySelectorAll('img[data-bxyz-original-src]');
      lingering.forEach((img) => {
        if (img.dataset.bxyzOriginalSrc) {
          img.src = img.dataset.bxyzOriginalSrc;
          delete img.dataset.bxyzOriginalSrc;
          processedImages.delete(img);
          // ta bort eventuella transitions
          img.style.transition = '';
        }
      });
      
      // säkerställ att body-klasser och stilar rensas
      document.body.classList.remove('bxyz-threshold-active');
      document.body.style.transition = '';
      document.body.style.opacity = '';
      
      // visa alla dolda textelement
      showTextElements();
    }, 100);
  }

  /**
   * kolla om threshold är aktiv
   */
  function isThresholdActive() {
    return thresholdActive;
  }

  // exponera global API
  window.BXYZ = window.BXYZ || {};
  window.BXYZ.threshold = {
    toggle: togglePageThreshold,
    enable: enablePageThreshold,
    disable: disablePageThreshold,
    isActive: isThresholdActive
  };

  // auto-init: lyssna på newsletter-trigger på alla sidor
  document.addEventListener('DOMContentLoaded', function() {
    const newsletterTrigger = document.querySelector('[data-bxyz-newsletter-trigger]');
    const footerWrapper = document.querySelector('.custom-footer-wrapper');
    
    // newsletter trigger hanteras nu direkt i footer-attach.liquid
    // if (newsletterTrigger) {
    //   newsletterTrigger.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     togglePageThreshold();
    //   });
    // }

    // lyssna på footer collapse (när newsletter stängs) och auto-revert
    if (footerWrapper) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isExpanded = footerWrapper.classList.contains('is-expanded');
            
            // om footer kollapsar och threshold är aktiv, stäng av threshold
            if (!isExpanded && thresholdActive) {
              disablePageThreshold();
            }
          }
        });
      });
      
      observer.observe(footerWrapper, {
        attributes: true,
        attributeFilter: ['class']
      });

      // lyssna på klick utanför footer för att stänga threshold
      document.addEventListener('click', (e) => {
        if (!thresholdActive) return;
        
        // om klick är utanför footer och threshold är aktiv, stäng av
        if (!footerWrapper.contains(e.target)) {
          const isExpanded = footerWrapper.classList.contains('is-expanded');
          if (isExpanded) {
            // footer är fortfarande öppen men användaren klickade utanför
            // stäng av threshold
            disablePageThreshold();
          }
        }
      });
    }

    // lyssna på custom triggers
    document.addEventListener('bxyz:threshold-toggle', function() {
      togglePageThreshold();
    });

    document.addEventListener('bxyz:threshold-enable', function() {
      enablePageThreshold();
    });

    document.addEventListener('bxyz:threshold-disable', function() {
      disablePageThreshold();
    });

    // lyssna på newsletter modal events för synkronisering
    document.addEventListener('bxyz:newsletter-opened', function() {
      enablePageThreshold();
    });

    document.addEventListener('bxyz:newsletter-closed', function() {
      disablePageThreshold();
    });
  });

})();
